import "./Header.css";
import NotificationsModal from "./NotficationsModal";
import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  Assignment,
  Dashboard,
  DocumentScanner,
  FormatListNumbered,
  HowToVote,
  MedicalInformation,
  Flag,
  PregnantWoman,
  Notifications,
  Menu,
  Close,
  Logout,
  CloudUpload,
} from "@mui/icons-material";
import ChatIcon from "@mui/icons-material/Chat";
import TextsmsIcon from "@mui/icons-material/Textsms";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPrescription } from "@fortawesome/free-solid-svg-icons";

function Header({ pageTitle, showBackButton, activeDiv, showDiv }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleGoBack = () => {
    const pathname = window.location.pathname;
    const pathParts = pathname.split("/");
    const patId = pathParts[pathParts.length - 2];
    pageTitle === "Discharge"
      ? navigate("/profile/" + patId)
      : window.history.back();
  };

  const handleNavClick = (divId) => {
    showDiv(divId);
    setSidebarOpen(false);
  };

  const handleLogout = () => {
    localStorage.removeItem("user_info");
    navigate('/');
  };

  const navigationItems = [
    {
      id: "appointments",
      icon: <Dashboard />,
      label: "Overview",
    },
    {
      id: "alerts",
      icon: <Notifications />,
      label: "Alerts",
    },
    {
      id: "treatmentPlan",
      icon: <ChatIcon />,
      label: "Chat",
    },
    {
      id: "send-sms",
      icon: <TextsmsIcon />,
      label: "Send SMS",
    },
    {
      id: "prescription",
      icon: <FontAwesomeIcon icon={faPrescription} />,
      label: "Prescription",
    },
    {
      id: "previous-prescriptions",
      icon: <FontAwesomeIcon icon={faPrescription} />,
      label: "Previous Prescriptions",
    },
    {
      id: "document",
      icon: <DocumentScanner />,
      label: "Medicines",
    },
    {
      id: "medical",
      icon: <MedicalInformation />,
      label: "Reports",
    },
    {
      id: "vitals",
      icon: <Assignment />,
      label: "Vitals",
    },
    {
      id: "task",
      icon: <FormatListNumbered />,
      label: "Notes",
    },
    {
      id: "assessment",
      icon: <HowToVote />,
      label: "Complaints",
    },
    {
      id: "risk_factors",
      icon: <Flag />,
      label: "Risk Factors",
    },
    {
      id: "ANCs",
      icon: <PregnantWoman />,
      label: "ANCs",
    },
    {
      id: "upload",
      icon: <CloudUpload />,
      label: "Upload Files",
    }
  ];

  // Check if we're on patient dashboard page
  const isPatientDashboard = showBackButton;

  return (
    <>
      <header className="App-header">
        <div className="headerSec p-4">
          <div className="row align-items-center">
            <div className="col">
              {showBackButton ? (
                <>
                  <button
                    type="button"
                    className="btn btn-link px-0 text-decoration-none profile-text !text-base"
                    onClick={handleGoBack}
                  >
                    <i className="fas fa-long-arrow-left me-1"></i>
                  </button>
                </>
              ) : (
                <h1 className="mb-0 header-text">{pageTitle}</h1>
              )}
              {location.pathname === "/" && (
                <div className="d-flex align-items-center">
                  <i className="fas fa-plus-circle me-1 text-green"></i>
                  <label className="me-2 ">
                    <Link
                      to={`/newPatient/page1`}
                      className="text-decoration-none"
                    >
                      Intake patient
                    </Link>
                  </label>
                </div>
              )}
            </div>
            <div className="col-auto">
              <div className="d-flex gap-4 align-items-center">
                <div>
                  <NotificationsModal />
                </div>
                <div className="d-flex align-items-center profileMenu col-auto">
                  <div className="flex-shrink-0">
                    <img src="/images/profile-icon.png" alt="" />
                  </div>
                  {/* <div className="flex-grow-1 ms-2 profile-name">
                    Walter Pearlman
                  </div> */}
                </div>
                {isPatientDashboard && (
                  <button
                    className="btn btn-link p-0 text-decoration-none"
                    onClick={() => setSidebarOpen(true)}
                    style={{ color: "#333" }}
                  >
                    <Menu fontSize="large" />
                  </button>
                )}
                <button
                  className="btn btn-link p-0 text-decoration-none"
                  onClick={handleLogout}
                  style={{ color: "#333" }}
                  title="Logout"
                >
                  <Logout fontSize="medium" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Sidebar Overlay */}
      {isPatientDashboard && sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-50"
          onClick={() => setSidebarOpen(false)}
        >
          <div
            className="fixed top-0 left-0 w-full h-full bg-white shadow-lg transform transition-transform duration-300 ease-in-out"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <div className="flex justify-end p-2">
              <button
                className="btn btn-link p-1 text-decoration-none"
                onClick={() => setSidebarOpen(false)}
                style={{ color: "#333" }}
              >
                <Close fontSize="medium" />
              </button>
            </div>

            {/* Navigation Items - Scrollable */}
            <div
              className="px-4 pb-4 overflow-y-auto"
              style={{ height: "calc(100vh - 60px)" }}
            >
              <div className="grid grid-cols-1 gap-3">
                {navigationItems.map((item) => (
                  <button
                    key={item.id}
                    className={`flex items-center p-3 rounded-lg border text-left transition-colors duration-200 ${
                      activeDiv === item.id
                        ? "bg-blue-100 border-blue-300"
                        : "bg-white border-gray-200 hover:bg-gray-50"
                    }`}
                    onClick={() => handleNavClick(item.id)}
                  >
                    <div className="mr-3 flex items-center justify-center">
                      {item.icon}
                    </div>
                    <span className="font-medium">{item.label}</span>
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Header;